import { Result, ResultProps } from 'antd'
import type { ResultStatusType } from 'antd/lib/result'
import React from 'react'
import { CustomModal } from 'src/components'

interface CustomResultModalProps extends ResultProps {
  isModalVisible: boolean
  handleCancel: () => void
  resultType: ResultStatusType
  mainLabel: string
}

const CustomResultModal: React.FC<CustomResultModalProps> = (props) => {
  const { isModalVisible, handleCancel, resultType, mainLabel, ...restProps } = props

  return (
    <CustomModal
      footer={null}
      open={isModalVisible}
      onCancel={handleCancel}
    >
      <div className='fade-animation'>
        <Result
          status={resultType}
          title={mainLabel}
          {...restProps}
        />
      </div>
    </CustomModal>
  )
}

export default CustomResultModal
